import { useState } from "react";
import { FileSpreadsheet, FileText, Loader2, Printer } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { cleanParams, download, errMsg } from "@/lib/api";

const PARTIES = [["kpis", "Indicateurs clés"], ["logements", "Réservations par logement"], ["repartition", "Répartition dépenses et revenus (avec le détail)"],
  ["soldes", "Soldes et revenus mensuels"], ["taxes", "Taxes, régularisations et anomalies"]];

// Impression du tableau de bord (période affichée) : PDF ou Excel des parties cochées
export const ExportTableauBord = ({ filters }) => {
  const [ouvert, setOuvert] = useState(false);
  const [choix, setChoix] = useState(PARTIES.map(([k]) => k));
  const [envoi, setEnvoi] = useState(null);
  const basculer = (k) => setChoix((c) => (c.includes(k) ? c.filter((x) => x !== k) : [...c, k]));
  const exporter = async (format) => {
    setEnvoi(format);
    try { await download("/dashboard/export", { ...cleanParams(filters), format, parties: choix.join(",") }, `Tableau de bord.${format}`); setOuvert(false); }
    catch (e) { toast.error(errMsg(e)); } finally { setEnvoi(null); }
  };
  return (
    <>
      <Button size="sm" variant="outline" onClick={() => setOuvert(true)} data-testid="dashboard-imprimer"><Printer className="h-3.5 w-3.5 mr-1" />PDF / Excel</Button>
      <Dialog open={ouvert} onOpenChange={setOuvert}>
        <DialogContent data-testid="dashboard-export-dialog">
          <DialogHeader>
            <DialogTitle>Imprimer le tableau de bord</DialogTitle>
            <DialogDescription>Période affichée à l'écran. Cochez les parties à inclure.</DialogDescription>
          </DialogHeader>
          <div className="space-y-3">
            {PARTIES.map(([k, l]) => (
              <label key={k} className="flex cursor-pointer items-center gap-3 text-sm" data-testid={`dashboard-export-partie-${k}`}>
                <Checkbox checked={choix.includes(k)} onCheckedChange={() => basculer(k)} data-testid={`dashboard-export-case-${k}`} />{l}
              </label>
            ))}
          </div>
          <DialogFooter className="gap-2">
            <Button variant="outline" disabled={!choix.length || !!envoi} onClick={() => exporter("xlsx")} data-testid="dashboard-export-excel">
              {envoi === "xlsx" ? <Loader2 className="h-4 w-4 mr-1 animate-spin" /> : <FileSpreadsheet className="h-4 w-4 mr-1" />}Excel
            </Button>
            <Button disabled={!choix.length || !!envoi} onClick={() => exporter("pdf")} className="bg-emerald-700 hover:bg-emerald-800" data-testid="dashboard-export-pdf">
              {envoi === "pdf" ? <Loader2 className="h-4 w-4 mr-1 animate-spin" /> : <FileText className="h-4 w-4 mr-1" />}PDF
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};
